import { EventBasicData } from "./event-basic-data.model"

export class SeasonEventRef {
	public storageId: number;
	public uuid: string;
	public merchantId: string;
	public oneTimeEvent: EventBasicData;
	public seasonEvents: EventBasicData[];
}



// WEBPACK FOOTER //
// ./src/app/models/season-event-ref.model.ts